<div class="tab-box">
    <div class="d-flex justify-content-start align-items-center">
        <a *ngFor="let x of tabs" (click)="selectTab( $event, x )" [ngClass]="x.selected  ? 'bg-dark-grey' : ''">
            {{x.text}}   
        </a>
    </div>
</div>
